import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getRedirectLocation } from '../../commons/js/utils/routes';
import { hasCredentials } from '../../commons/js/utils/hasCredentials';
// import { clearLocalStorage } from '../../commons/js/utils/clearLocalStorage'


const Authorized = (WrappedComponent, allowedRoles) => {
    class AuthorizedWrapper extends Component {
        constructor(props) {
            super(props);

            this.isAuthorized = this.isAuthorized.bind(this)
        }

        isAuthorized() {
            const role = this.props.role;
            if (role) {
                return allowedRoles.includes(role)
            } else {
                return false
            }
        }

        render() {
            if (this.isAuthorized()) {
                return (
                    <WrappedComponent {...this.props} />
                );
            } else {
                let redirectLocation = getRedirectLocation();
                return (
                    <Redirect to={`${redirectLocation}`} />
                )
            }
        }
    }

    return connect((state) => ({
        role: state.session.role,
    }))(AuthorizedWrapper)

}

const Authenticated = (WrappedComponent, allowedRoles = null, reverseMode = false) => {
    class AuthenticatedWrapper extends Component {
        constructor(props) {
            super(props);

            // if(this.props.isLoggedIn){
            //     if(this.hasCredentials()){

            //     }else{
            //         this.props.logout();
            //     }
            // } else {
            //     if(this.hasCredentials()){
            //         this.props.setLoggedIn(localStorage.getItem("role"));
            //     }else{

            //     }
            // }

            this.isLoggedIn = this.isLoggedIn.bind(this)
        }

        // componentDidUpdate(){

        // }

        // hasCredentials(){
        //     let token = localStorage.getItem("token");
        //     let role = localStorage.getItem("role");
        //     let userId = localStorage.getItem("userId");

        //     return !!(token && role && userId);
        // }

        isLoggedIn() {
            // let authenticated;
            // // Check for isLoggedIn flag in state
            // // If flag exists and is true, use the value
            // if (this.props.isLoggedIn) {
            //     if(this.hasCredentials()){
            //         authenticated = true
            //     } else {
            //         this.props.logout();
            //         authenticated = false
            //     }
            // } else {
            //     // If not, try reading token from local storage and set flag
            //     if (this.hasCredentials()) {
            //         this.props.setLoggedIn(localStorage.getItem("role"));
            //         authenticated = true
            //     } else {
            //         authenticated = false
            //     }
            // }

            // return authenticated
            return hasCredentials();
        }

        render() {
            let Target;

            if (allowedRoles) {
                Target = Authorized(WrappedComponent, allowedRoles)
            } else {
                Target = WrappedComponent
            }

            const { isLoggedIn, role, ...passThroughProps } = this.props;
            if (!reverseMode) {
                if (this.isLoggedIn()) {
                    return (
                        <Target {...passThroughProps} />
                    )
                } else {
                    if(this.props.wasLoggedIn) {
                        return (<Redirect to={'/login'}></Redirect>)
                    } else {
                        // clearLocalStorage();
                        // this.props.logout()
                        return (
                            <Redirect to={{pathname:'/login', state:{from: this.props.location}}}></Redirect>
                        );
                    }
                }
            } else {
                if (this.isLoggedIn()) {
                    let redirectLocation = getRedirectLocation();
                    let location = this.props.location
                    if (location.state && location.state.from) {
                        let url = `${location.state.from.pathname}${(location.state.from.search)?location.state.from.search:location.state.from.hash}`;
                        return (<Redirect to={url} />)
                    }else {
                        return (
                            <Redirect to={`${redirectLocation}`}/>
                        )
                    }
                } else {
                    return (
                        <Target {...passThroughProps} />
                    );
                }
            }
        }
    }

    return connect((state) => ({
        isLoggedIn: state.session.isLoggedIn,
        wasLoggedIn: state.session.wasLoggedIn,
        role: state.session.role,
    }), (dispatch) => ({
        setLoggedIn: (role) => {
            dispatch({
                type: "SET_LOGGED_IN",
                payload: {
                    role: role,
                    value: true,
                }
            })
        },
        logout: () => {
            dispatch({
                type: "LOGOUT",
            })
        }
    }))(AuthenticatedWrapper)
}

export default Authenticated;
